import { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import SearchResult from 'components/SearchResult'
import PageLoader from 'components/PageLoader'
import Header from 'components/Header'
import Footer from 'components/Footer'
import BackButton from 'components/BackButton'
import { getSearchTerm } from 'modules/home/HomeSelector'

import styles from './SingleLayout.module.sass'

const crypto = window.crypto || window.msCrypto
let random = new Uint32Array(1)
const isActivationKey = key => key === 'Enter' || key === ' '

const SingleLayout = ({ children, isLoading }) => {
  const searchTerm = useSelector(getSearchTerm)
  const [menuOpen, setMenuOpen] = useState(false)

  const isSearching = Boolean(searchTerm?.length)

  const closeMenu = useCallback(() => {
    setMenuOpen(crypto?.getRandomValues(random)[0])
  }, [])

  const closeMenuFromEvent = useCallback(
    e => {
      if (!e || e.type === 'click' || isActivationKey(e.key)) {
        closeMenu(crypto?.getRandomValues(random)[0])
      }
    },
    [closeMenu]
  )

  const content = useMemo(() => {
    if (isSearching) return <SearchResult />
    return (
      <>
        {children}
        <BackButton />
      </>
    )
  }, [children, isSearching])

  return (
    <div className={styles.box}>
      <Header menuOpen={menuOpen} />
      <div className={styles.gap}></div>
      <div
        role="button"
        tabIndex={0}
        data-testid={isSearching ? 'search' : 'content'}
        className={styles.content}
        onClick={closeMenuFromEvent}
        onKeyDown={closeMenuFromEvent}
      >
        {content}
      </div>
      <Footer setMenuOpen={closeMenu} />
      {isLoading && <PageLoader />}
    </div>
  )
}

SingleLayout.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool
}

export default SingleLayout
